import $ from 'jquery'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = 'pk.eyJ1IjoiZmxpcHBkZXZzIiwiYSI6ImNrc2hxc2x0ZDF3eGQyb29hZDNndWhuZXcifQ.NLQN5AjdofpVMB8SBRgDgA';

if( $( '#showhomes-map' ).length ) {
  $( '#map' ).one( 'click', function( e ) {
  const map = new mapboxgl.Map({
    container: 'showhomes-map',
    style: 'mapbox://styles/flippdevs/cliakynko002001r95iciayf9',
    center: [-114.082960, 50.982971 ],
    zoom: 10
  });

  map.on('idle',function(){
    map.resize()
  })
  // disable map zoom when using scroll
  map.scrollZoom.disable();

  const nav = new mapboxgl.NavigationControl({
  showCompass: false
  });
  map.addControl(nav, 'bottom-right');

  const mapLegend = document.querySelectorAll( '.cpt-card' );

  mapLegend.forEach( ( legend, index ) => {

    let long = legend.dataset.long;
    let lat = legend.dataset.lat;
    let title = $( '.showhome-title' )[index].innerHTML;
    let el = document.createElement('div');

    if( long != 0 && lat != 0 )  {

      const marker = new mapboxgl.Marker(el, {offset: [0, 10]}).setLngLat([long, lat]).addTo(map);

      el.className = 'marker';  
      el.innerHTML =  `<p class="marker-text">${title}</p>`;    
      
      //takes the original cpt-card dataset and assigns it to the marker
      let data = legend.dataset;

      for ( let key in data ) {
        el.setAttribute('data-'+ key, data[key] )
      }
  
      el.addEventListener( 'click', function() {
        
        map.flyTo({
          center: [long, lat], 
          zoom: 17, 
          // speed: 0.4,
        });
      });
    }

  })
  map.on('move', () => {

    if( map.getZoom() >= 16) {
      $( '.marker-text' ).removeClass( 'hide');
    } else {
      $( '.marker-text' ).addClass( 'hide');
    }
  });

  if (  query && query.startsWith( '?city=edmonton' )  ){
    map.flyTo({
      center: [ -113.493972, 53.532920], 
      zoom: 10, 
      // speed: 0.9,
    });
  }

  

  const markerLegend = document.querySelectorAll( '.marker' );

  $( '.filter input, select' ).on( 'change', function() { 
    // console.log( this )
    // mapLegend.forEach( ( legend, index ) => {

    //   if( $( legend ).css( 'display' ) == 'none' )  {
    //     $( markerLegend[ index ] ).addClass( 'hide' );     
    //   } else {
    //     $( markerLegend[ index ] ).removeClass( 'hide' );   
    //   }
    // })

    // markerLegend.forEach( ( marker ) => {
    //   if( $( this ).val() == $( marker ).data( 'listing' ) ) {
    //     $( marker ).removeClass( 'hide' )
    //   } else {
    //     $( marker ).addClass( 'hide' )
    //   }
    // } )
    
    // if( $( "input[name='view']:checked" ).val() == 'map' ) {

    //   let results = $( '.marker' ).filter( function() {
    //     return $( this ).css( 'display' ) == 'flex'
    //   }).length

    //   $( '#results' ).html( results );  
    // }
    if( $( this ).attr( 'value' ) == 'calgary' ) {
      map.flyTo({
        center: [-114.082960, 50.982971 ],
        zoom: 10, 
        // speed: 0.9,
      });
    } else if( $( this ).attr( 'value' ) == 'edmonton' ) {
      map.flyTo({
        center: [ -113.493972, 53.532920], 
        zoom: 10, 
        // speed: 0.9,
      });
    }
  })
  $( "input[value='map']" ).on( 'click', function() {
    setTimeout( () => {
      map.resize();
    }, 100 )  
  })
  //this sets calgary as the city by default, needs to run after change event is defined
  // $( 'input:radio[ value="calgary" ]' ).attr('checked', true).trigger( 'change' );
  });
}
